import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RitImageBlock from '../RitImageBlock/RitImageBlock';

const Container = styled.div`
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageTitle = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    background: white;
    padding: 5px;
    border-radius: 2px;
`;

export const FontPreviewContent = ({ items }) => {

    const imageLinks = {
        'Arial': 'arial_eng.jpg',
        'MonotypeCorsiva' : 'monotype_eng.jpg',
        'OldEnglish': 'old_english_eng.jpg',
        'MiniCorsiva': 'mini_coursive.jpg',
        'Verdana': 'verdana_eng.jpg',
    };


    return (
        <Container>
            {items.map((item, i) => {
                return (
                    <ImageWrapper key={i}>
                        <ImageTitle>{item.attrValue}</ImageTitle>
                        <RitImageBlock src={`/images/details/${imageLinks[item.attrValue]}`} />
                    </ImageWrapper>
                )
            })}
        </Container>
    );
}

FontPreviewContent.propTypes = {
    items: PropTypes.array.isRequired,
}